import { AxiosResponse } from 'axios'

import { PBPResponse } from '@percent/cause-dashboard/services/types/pbpResponses.types'

export const getDataFromPBPResponse = <A>({ data }: AxiosResponse<PBPResponse<A>>) => data.data
